import React from "react";
import "./Contact.css";
import { GrMapLocation, GrMail } from "react-icons/gr";


const Contact = () => {
  return (
    <section id="contact">
      <div className="contact-container">
        <div className="contact-title">
          <p>Contact me</p>
          <h2>
            <span>Let's</span> Talk
          </h2>
        </div>


        <div className="form">
          <form
            action="https://getform.io/f/bqokxqlb"
            method="POST"
            autoComplete="off"
          >
            <input type="hidden" name="_gotcha" id="honeypot" />
            <input
              type="text"
              name="name"
              id="name"
              required
              placeholder="Enter your name"
            />
            <input
              type="email"
              name="email"
              id="email"
              required
              placeholder="Enter your email"
            />
            <textarea
              name="message"
              id="message"
              cols="30"
              rows="10"
              placeholder="Enter your message"
              required
            ></textarea>
            <button type="submit">Send message</button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Contact;
